import './headless-scene-components.js'
import gql from 'graphql-tag'

import { ReferenceMap, create, error } from '@hatiolab/things-scene'

export { BoardViewer, BoardPlayer } from '../board/index.js'
import { client, gqlContext, subscribe } from '@operato/graphql'

export const provider = new ReferenceMap(
  async (boardId, resolve, reject) => {
    try {
      const response = await client.query({
        query: gql`
          query FetchBoardById($id: String!) {
            board(id: $id) {
              model
            }
          }
        `,
        variables: { id: boardId },
        context: gqlContext()
      })

      const board = response.data.board

      var model = JSON.parse(board.model)

      var scene

      try {
        scene = await provider.get(boardId)
        console.warn('Board fetched more than twice.', boardId)
      } catch (e) {
        scene = create({
          model,
          mode: 0,
          refProvider: provider
        })

        // s.app.baseUrl = undefined;
      }

      resolve(scene)
    } catch (e) {
      error(e)
      reject(e)
    }
  },
  async (id, ref) => {
    ref.dispose()
  }
)

var subscriptionForAutoRefresh

export const startSubscribingForAutoRefresh = async (playGroupId, callback) => {
  if (!playGroupId) {
    return
  }

  await stopSubscribing()

  subscriptionForAutoRefresh = await subscribe(
    {
      query: gql`
        subscription ($id: String!) {
          playGroup(id: $id) {
            id
            boards {
              id
              model
            }
          }
        }
      `,
      variables: {
        id: playGroupId
      }
    },
    {
      next: async ({ data }) => {
        const { id, boards = '{}' } = data.playGroup

        if (data) {
          callback &&
            (await callback({
              id,
              boards
            }))
        }
      }
    }
  )
}

export const stopSubscribing = async () => {
  await subscriptionForAutoRefresh?.unsubscribe()
  subscriptionForAutoRefresh = null
}

window['headlessSceneProvider'] = provider
window['startSubscribingForAutoRefresh'] = startSubscribingForAutoRefresh
window['stopSubscribing'] = stopSubscribing
